import { ElementType, MouseEvent, RefObject } from "react";
import { Tooltip, TooltipProps } from "@chakra-ui/react";
import { Flex, FlexProps, ThemeTypings, ButtonProps } from "@/ui";
import { useButtonStateColors } from "@/theme/utils/getButtonStateColor";
import { useTooltips } from "@/lib/TooltipManager";
import Icon from "./Icon";

type Props = {
  icon: any;
  fill?: ThemeTypings["colors"];
  bg?: ThemeTypings["colors"];
  p?: string;
  onClick?: Cb<MouseEvent>;
  as?: ElementType;
  props?: FlexProps & ButtonProps;
  iconSize?: string;
  tooltip?: Omit<TooltipProps, "children">;
  ref?: RefObject<HTMLDivElement | null>;
};

export default function IconButton({
  onClick,
  bg,
  icon,
  fill = "neutral.99",
  as = "button",
  p = "8",
  iconSize,
  tooltip,
  props,
  ref
}: Props) {
  const { active, hover } = useButtonStateColors(fill, bg);
  const tooltipController = useTooltips();

  return (
    <Tooltip
      {...(tooltip ? { gutter: 4, ...tooltip } : { isDisabled: true })}
      isOpen={tooltipController.isOpen}
      onClose={tooltipController.close}
    >
      <Flex
        onPointerEnter={tooltipController.open}
        ref={ref}
        onClick={(e) => {
          tooltipController.close();
          onClick?.(e);
        }}
        borderRadius="100%"
        transition="background 0.3s"
        bg={bg}
        as={as}
        p={p}
        _hover={{ bg: hover }}
        _active={{ bg: active }}
        _focusVisible={{
          transition: "box-shadow 0.2s",
          boxShadow: "elevation1",
          outline: "none"
        }}
        {...props}
      >
        <Icon icon={icon} fill={fill} size={iconSize} />
      </Flex>
    </Tooltip>
  );
}
